// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable } from 'rxjs';

// --- 3rd Party
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// --- HS Code
import {
  NotificationModel,
  NotificationTypes,
  ReportListItem,
  ReportRequestModel,
  SavedReportTypes,
} from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root',
})
export abstract class ReportsBaseService {
  protected _reportsList$: BehaviorSubject<ReportListItem[]>;
  get reportsList$(): Observable<ReportListItem[]> {
    return this._reportsList$;
  }

  protected _reportIsLoading$: BehaviorSubject<boolean>;
  get reportIsLoading$(): Observable<boolean> {
    return this._reportIsLoading$;
  }

  protected _reportIsDownloading$: BehaviorSubject<boolean>;
  get reportIsDownloading$(): Observable<boolean> {
    return this._reportIsDownloading$;
  }

  constructor(protected modalService: NgbModal) {
    this._reportsList$ = new BehaviorSubject<ReportListItem[]>(
      new Array<ReportListItem>()
    );
    this._reportIsLoading$ = new BehaviorSubject<boolean>(false);
    this._reportIsDownloading$ = new BehaviorSubject<boolean>(false);
  }

  public updateReportStatusFromNotifications(
    notifications: NotificationModel[]
  ): void {
    const _reports = Object.assign(
      new Array<ReportListItem>(),
      this._reportsList$.value
    );
    if (!Array.isArray(_reports) || !Array.isArray(notifications)) {
      return;
    }
    _reports.forEach((report) => {
      const notification = notifications.find(
        (n) => n.identifier.toLowerCase() === report.surveyId.toLowerCase()
      );
      if (
        notification &&
        notification.type === NotificationTypes.reportDownloadReady
      ) {
        report.IsReportInProgress = false;
        report.busy = false;
        report.hasReport = true;
      }
    });
    this._reportsList$.next(_reports);
  }

  protected _toggleReportLoading(identifier: string, isLoading = false): void {
    if (!isLoading && Array.isArray(this._reportsList$.value)) {
      const _reports = this._reportsList$.value;

      _reports.forEach((report) => {
        if (report.surveyId === identifier) {
          report.busy = isLoading;
        }
      });

      this._reportsList$.next(_reports);
    }
  }

  abstract loadReports(): void;
  abstract getReportPdf(identifier: string, savedReportType: SavedReportTypes): void;
  abstract regenerateReportPdf(identifier: string): void;
  abstract submitReportRequest(model: ReportRequestModel): void;
  abstract getJournalReportPdf(): void;
}
